export default __webpack_public_path__ + "img/chevron-right.5e0ec642.svg";